import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FuseNavigationService } from './navigation.service';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from './../../../main/content/Seguridad/auth.service';
import { InfoSesion } from './../../../main/content/Global/InfoSesion.model';

@Component({
    selector     : 'fuse-navigation',
    templateUrl  : './navigation.component.html',
    styleUrls    : ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FuseNavigationComponent implements OnDestroy
{
    navigationModel: any[];
    navigationModelChangeSubscription: Subscription;

    @Input('layout') layout = 'vertical';

    constructor(private fuseNavigationService: FuseNavigationService, private _authService:AuthService)
    {

        this.navigationModelChangeSubscription =
        this.fuseNavigationService.onNavigationModelChange
        .subscribe((navigationModel) => {
            this.navigationModel = navigationModel;
        });

        let infoSesion:InfoSesion = _authService.getInfoSesion();
        if(infoSesion != undefined && infoSesion != null && infoSesion.model != undefined ){
            fuseNavigationService.setNavigationModel(infoSesion.model);
        }
    }

    ngOnDestroy()
    {
        this.navigationModelChangeSubscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/core/components/navigation/navigation.component.ts